import "./assets/css/boxicons.css";
import "./assets/css/core.css";
import "./assets/css/demo.css";
import "./assets/css/theme-default.css";
import "./assets/css/auth.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/style.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import Layout from "./components/common/Layout";
import PrivateRoute from "./components/common/PrivateRoute";
import PrivateAdminRoute from "./components/common/PrivateAdminRoute";
import PrivatePermissionRoute from "./components/common/PrivatePermissionRoute";
import LoginPage from "./pages/Login/LoginPage";
import ForgotPasswordPage from "./pages/Login/ForgotPasswordPage";
import PrivacyPolicyPage from "./pages/Others/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/Others/TermsAndConditionsPage";
import ForumSettingsEdit from "./pages/ForumSettings/ForumSettingsEdit";
import ApplicationProvider from "./context/ApplicationProvider";
import UsersList from "./pages/Users/UsersList";
import UserCreate from "./pages/Users/UserCreate";
import UserEdit from "./pages/Users/UserEdit";
import NewsList from "./pages/News/Newslist";
import NewsCreate from "./pages/News/NewsCreate";
import NewsEdit from "./pages/News/NewsEdit";
import AdminList from "./pages/Admin/AdminList";
import CreateAdmin from "./pages/Admin/CreateAdmin";
import EditAdmin from "./pages/Admin/EditAdmin";
import {
  ADMIN_LIST_PERMISSIONS,
  ADMIN_CREATE_PERMISSIONS,
  ADMIN_EDIT_PERMISSIONS,
} from "./pages/Admin/adminTypeConfig";
import CountrysList from "./pages/Countrys/CountrysList";
import CreateCountry from "./pages/Countrys/CreateCountry";
import EditCountry from "./pages/Countrys/EditCountry";
import StatesList from "./pages/States/StatesList";
import CreateState from "./pages/States/CreateState";
import EditState from "./pages/States/EditState";
import CitysList from "./pages/Citys/CitysList";
import CreateCity from "./pages/Citys/CreateCity";
import EditCity from "./pages/Citys/EditCity";
import RegionsList from "./pages/Regions/RegionsList";
import CreateRegion from "./pages/Regions/CreateRegion";
import EditRegion from "./pages/Regions/EditRegion";
import ChaptersList from "./pages/Chapters/ChaptersList";
import CreateChapter from "./pages/Chapters/CreateChapter";
import EditChapter from "./pages/Chapters/EditChapter";
import UserRolesList from "./pages/UserRoles/UserRolesList";
import CreateUserRole from "./pages/UserRoles/CreateUserRole";
import EditUserRole from "./pages/UserRoles/EditUserRole";
import CategoryList from "./pages/Category/CategoryList";
import CreateCategory from "./pages/Category/CreateCategory";
import EditCategory from "./pages/Category/EditCategory";
import BusinessSubCategoryList from "./pages/BusinessSubCategory/BusinessSubCategoryList";
import CreateBusinessSubCategory from "./pages/BusinessSubCategory/CreateBusinessSubCategory";
import EditBusinessSubCategory from "./pages/BusinessSubCategory/EditBusinessSubCategory";
import BloodgroupList from "./pages/Bloodgroup/BloodgroupList";
import CreateBloodgroup from "./pages/Bloodgroup/CreateBloodgroup";
import EditBloodgroup from "./pages/Bloodgroup/EditBloodgroup";
import CurrencyList from "./pages/Currency/CurrencyList";
import CreateCurrency from "./pages/Currency/CreateCurrency";
import EditCurrency from "./pages/Currency/EditCurrency";
import CrownsList from "./pages/Crowns/CrownsList";
import CreateCrown from "./pages/Crowns/CreateCrown";
import EditCrown from "./pages/Crowns/EditCrown";
import IncomeCategoryList from "./pages/IncomeCategory/IncomeCategoryList";
import CreateIncomeCategory from "./pages/IncomeCategory/CreateIncomeCategory";
import EditIncomeCategory from "./pages/IncomeCategory/EditIncomeCategory";
import ExpenseCategoryList from "./pages/ExpenseCategory/ExpenseCategoryList";
import CreateExpenseCategory from "./pages/ExpenseCategory/CreateExpenseCategory";
import EditExpenseCategory from "./pages/ExpenseCategory/EditExpenseCategory";
import PostsCategoryList from "./pages/PostsCategory/PostsCategoryList";
import CreatePostsCategory from "./pages/PostsCategory/CreatePostsCategory";
import EditPostsCategory from "./pages/PostsCategory/EditPostsCategory";
import SponsorsCategoryList from "./pages/SponsorsCategory/SponsorsCategoryList";
import CreateSponsorCategory from "./pages/SponsorsCategory/CreateSponsorCategory";
import EditSponsorCategory from "./pages/SponsorsCategory/EditSponsorCategory";
import FeedPostsList from "./pages/FeedPosts/FeedPostsList";
import IncomesList from "./pages/Incomes/IncomesList";
import ExpensesList from "./pages/Expenses/ExpensesList";
import SponsorsList from "./pages/Sponsors/SponsorsList";


import TimersList from "./pages/Timers/TimersList";
import CreateTimer from "./pages/Timers/CreateTimer";
import EditTimer from "./pages/Timers/EditTimer";
import EditTimerAccess from "./pages/Timers/EditTimerAccess";
import EditChapterFinanceAccess from "./pages/ChapterFinanceAccess/EditChapterFinanceAccess";
import RolesList from "./pages/Roles/RolesList";
import CreateRole from "./pages/Roles/CreateRole";
import EditRole from "./pages/Roles/EditRole";
import TyfcbList from "./pages/Tyfcb/TyfcbList";
import WeeklyMeetingsList from "./pages/MeetingSchedules/WeeklyMeetingsList";
import SchedulesList from "./pages/MeetingSchedules/SchedulesList";
import AttendanceList from "./pages/Attendance/AttendanceList";
import TrainingList from "./pages/Training/TrainingList";
import TrainingAttendance from "./pages/Training/TrainingAttendance";
import OnetoOneList from "./pages/OnetoOne/OnetoOneList";
import ReferralsList from "./pages/Referrals/ReferralsList";
import VisitorsList from "./pages/Visitors/VisitorsList";
import ChangePassword from "./pages/Login/ChangePassword";
import Settings from "./pages/Login/Settings";
import Logout from "./pages/Login/Logout";
import WeeklyFeesList from "./pages/MeetingSchedules/WeeklyFeesList";
import EventsList from "./pages/Events/EventsList";
import CreateEvent from "./pages/Events/CreateEvent";
import EditEvent from "./pages/Events/EditEvent";

import TyfcbReportsList from "./pages/Reports/TyfcbReportsList";
import BizgivenReportsList from "./pages/Reports/BizgivenReportsList";
import OnetoOneReportsList from "./pages/Reports/OnetoOneReportsList";
import ReferralsReportsList from "./pages/Reports/ReferralsReportsList";
import VisitorsReportsList from "./pages/Reports/VisitorsReportsList";
import FeesReportsList from "./pages/Reports/FeesReportsList";
import OverallReportsList from "./pages/Reports/OverallReportsList";
import AttendanceReportsList from "./pages/Reports/AttendanceReportsList";
import TrainingReportsList from "./pages/Reports/TrainingReportsList";
import PointsReportsList from "./pages/Reports/PointsReportsList";
import MonthlyPointsReportsList from "./pages/Reports/MonthlyPointsReportsList";
import LedgerReportsList from "./pages/Reports/LedgerReportsList";
import MembershipExpiryRenewalReportsList from "./pages/Reports/MembershipExpiryRenewalReportsList";

import TestimonialsList from "./pages/Testimonials/TestimonialsList";
import PointsSystem from "./pages/Points/PointsSystem";
import MemberMonthlyReportsList from "./pages/MemberMonthlyReports/MemberMonthlyReportsList";

function App() {
  return (
    <>
      <ApplicationProvider>
        <ToastContainer theme="dark" autoClose={3000} hideProgressBar />
        <Router>
          <Routes>
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Layout />}>
               
                {/* --- Dashboard --- */}
                <Route
                  element={<PrivatePermissionRoute permission="dashboard-view" />}
                >
                  <Route index path="/" element={<Dashboard />} />
                  <Route index path="/home" element={<Dashboard />} />
                  <Route index path="/dashboard" element={<Dashboard />} />
                </Route>
                {/* --- Unified Admins --- */}
                <Route
                  element={
                    <PrivateAdminRoute allowedRoles={[1, 6, 7, 8, 2]} />
                  }
                >
                  <Route
                    element={
                      <PrivatePermissionRoute
                        permissions={ADMIN_LIST_PERMISSIONS}
                      />
                    }
                  >
                    <Route path="/admins" element={<AdminList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute
                        permissions={ADMIN_CREATE_PERMISSIONS}
                      />
                    }
                  >
                    <Route path="/admins/create" element={<CreateAdmin />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute
                        permissions={ADMIN_EDIT_PERMISSIONS}
                      />
                    }
                  >
                    <Route
                      path="/admins/:type/:id/edit"
                      element={<EditAdmin />}
                    />
                  </Route>
                </Route>
                {/* --- Members --- */}
                <Route
                  element={<PrivatePermissionRoute permission="members-list" />}
                >
                  <Route path="/users" element={<UsersList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="members-create" />
                  }
                >
                  <Route path="/user/create" element={<UserCreate />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="members-edit" />}
                >
                  <Route path="/user/:id/edit" element={<UserEdit />} />
                </Route>
                {/* --- Meeting Schedules --- */}
                <Route
                  element={<PrivatePermissionRoute permission="meeting-schedules-list" />}
                >
                  <Route path="/weekly-meetings" element={<WeeklyMeetingsList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="training-list" />}
                >
                  <Route path="/trainings" element={<TrainingList />} />
                  <Route path="/trainings/:id/attendance" element={<TrainingAttendance />} />
                </Route>
                {/* --- Attendance --- */}
                <Route
                  element={<PrivatePermissionRoute permission="meeting-schedules-list" />}
                >
                  <Route path="/attendance" element={<AttendanceList />} />
                </Route>
                {/* --- Meeting Fees --- */}
                <Route
                  element={<PrivatePermissionRoute permission="meeting-fees-list" />}
                >
                  <Route path="/weekly-fees" element={<WeeklyFeesList />} />
                </Route>
                {/* --- 121s --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="121s-list" />
                  }
                >
                  <Route path="/one-to-one" element={<OnetoOneList />} />
                </Route>
                {/* --- RFLs --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="referrals-list" />
                  }
                >
                  <Route path="/referrals" element={<ReferralsList />} />
                </Route>
                {/* --- TYNs --- */}
                <Route
                  element={<PrivatePermissionRoute permission="tyfcbs-list" />}
                >
                  <Route path="/tyfcbs" element={<TyfcbList />} />
                </Route>
                {/* --- Visitors --- */}
                {/* Client: General / Chief Guest / Power Date paused — comment only, do not remove
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-general-list" />
                  }
                >
                  <Route
                    path="/visitors/general"
                    element={
                      <VisitorsList visitType="0" visitTypeText="General" />
                    }
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-chief-guest-list" />
                  }
                >
                  <Route
                    path="/visitors/chief-guest"
                    element={
                      <VisitorsList visitType="1" visitTypeText="Chief Guest" />
                    }
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-power-date-list" />
                  }
                >
                  <Route
                    path="/visitors/power-date"
                    element={
                      <VisitorsList visitType="2" visitTypeText="Power Date" />
                    }
                  />
                </Route>
                */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-inductions-list" />
                  }
                >
                  <Route
                    path="/visitors/inductions"
                    element={
                      <VisitorsList visitType="3" visitTypeText="Inductions" />
                    }
                  />
                </Route>
                {/* --- Events --- */}
                <Route
                  element={<PrivatePermissionRoute permission="events-list" />}
                >
                  <Route path="/events" element={<EventsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="events-create" />
                  }
                >
                  <Route path="/create/event" element={<CreateEvent />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="events-edit" />}
                >
                  <Route path="/event/:id/edit" element={<EditEvent />} />
                </Route>
                {/* --- News Feed --- */}
                <Route
                  element={<PrivatePermissionRoute permission="news-list" />}
                >
                  <Route path="/news" element={<NewsList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="news-create" />}
                >
                  <Route path="/news/create" element={<NewsCreate />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="news-edit" />}
                >
                  <Route path="/news/:id/edit" element={<NewsEdit />} />
                </Route>
                {/* --- Leads --- */}
                <Route
                  element={<PrivatePermissionRoute permission="feed-posts-list" />}
                >
                  <Route path="/feed-posts" element={<FeedPostsList />} />
                </Route>
                {/* --- Incomes --- */}
                <Route
                  element={<PrivatePermissionRoute permission="incomes-list" />}
                >
                  <Route path="/incomes" element={<IncomesList />} />
                </Route>
                {/* --- Expenses --- */}
                <Route
                  element={<PrivatePermissionRoute permission="expenses-list" />}
                >
                  <Route path="/expenses" element={<ExpensesList />} />
                </Route>
                {/* --- Sponsors --- */}
                <Route
                  element={<PrivatePermissionRoute permission="sponsors-list" />}
                >
                  <Route path="/sponsors" element={<SponsorsList />} />
                </Route>
                {/* --- Testimonials --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="testimonials-list" />
                  }
                >
                  <Route path="/testimonials" element={<TestimonialsList />} />
                </Route>

                {/* --- Reports --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-tyns-list" />
                  }
                >
                  <Route
                    path="/reports/tyfcbs"
                    element={<TyfcbReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-biz-given-list" />
                  }
                >
                  <Route
                    path="/reports/biz-given"
                    element={<BizgivenReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-121s-list" />
                  }
                >
                  <Route
                    path="/reports/one-to-one"
                    element={<OnetoOneReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-referrals-list" />
                  }
                >
                  <Route
                    path="/reports/referrals"
                    element={<ReferralsReportsList />}
                  />
                </Route>

                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-visitors-list" />
                  }
                >
                  <Route
                    path="/reports/visitors"
                    element={<VisitorsReportsList />}
                  />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="reports-reward-points" />}
                >
                  <Route path="/reports/points" element={<PointsReportsList />} />
                  <Route path="/reports/monthly-points" element={<MonthlyPointsReportsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-fees-list" />
                  }
                >
                  <Route path="/reports/fees" element={<FeesReportsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-attendance-list" />
                  }
                >
                  <Route
                    path="/reports/attendance"
                    element={<AttendanceReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission={["reports-training-list", "reports-attendance-list", "training-list"]} />
                  }
                >
                  <Route
                    path="/reports/training"
                    element={<TrainingReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-overall-list" />
                  }
                >
                  <Route
                    path="/reports/overall"
                    element={<OverallReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-membership-expiry-renewal-list" />
                  }
                >
                  <Route
                    path="/reports/membership-expiry-renewals"
                    element={<MembershipExpiryRenewalReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-ledger-list" />
                  }
                >
                  <Route
                    path="/reports/ledger"
                    element={<LedgerReportsList />}
                  />
                </Route>
                {/* --- Masters --- */}
                {/* --- User Roles --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="user-roles-list" />
                  }
                >
                  <Route path="/user-roles" element={<UserRolesList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="user-roles-create" />
                  }
                >
                  <Route
                    path="/create/user-role"
                    element={<CreateUserRole />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="user-roles-edit" />
                  }
                >
                  <Route
                    path="/user-role/:id/edit"
                    element={<EditUserRole />}
                  />
                </Route>
                {/* --- Business Category --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="business-category-list" />
                  }
                >
                  <Route path="/category" element={<CategoryList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="business-category-create" />
                  }
                >
                  <Route
                    path="/create/category"
                    element={<CreateCategory />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="business-category-edit" />
                  }
                >
                  <Route
                    path="/category/:id/edit"
                    element={<EditCategory />}
                  />
                </Route>
                {/* --- Business Sub Category --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="business-sub-category-list" />
                  }
                >
                  <Route
                    path="/business-sub-category"
                    element={<BusinessSubCategoryList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="business-sub-category-create" />
                  }
                >
                  <Route
                    path="/create/business-sub-category"
                    element={<CreateBusinessSubCategory />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="business-sub-category-edit" />
                  }
                >
                  <Route
                    path="/business-sub-category/:id/edit"
                    element={<EditBusinessSubCategory />}
                  />
                </Route>
                {/* --- Income Category --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="income-category-list" />
                  }
                >
                  <Route path="/income-category" element={<IncomeCategoryList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="income-category-create" />
                  }
                >
                  <Route
                    path="/create/income-category"
                    element={<CreateIncomeCategory />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="income-category-edit" />
                  }
                >
                  <Route
                    path="/income-category/:id/edit"
                    element={<EditIncomeCategory />}
                  />
                </Route>
                {/* --- Expense Category --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="expense-category-list" />
                  }
                >
                  <Route path="/expense-category" element={<ExpenseCategoryList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="expense-category-create" />
                  }
                >
                  <Route
                    path="/create/expense-category"
                    element={<CreateExpenseCategory />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="expense-category-edit" />
                  }
                >
                  <Route
                    path="/expense-category/:id/edit"
                    element={<EditExpenseCategory />}
                  />
                </Route>
                {/* --- Leads Category --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="posts-category-list" />
                  }
                >
                  <Route path="/posts-category" element={<PostsCategoryList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="posts-category-create" />
                  }
                >
                  <Route
                    path="/create/posts-category"
                    element={<CreatePostsCategory />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="posts-category-edit" />
                  }
                >
                  <Route
                    path="/posts-category/:id/edit"
                    element={<EditPostsCategory />}
                  />
                </Route>
                {/* --- Sponsors Category --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="sponsors-category-list" />
                  }
                >
                  <Route path="/sponsors-category" element={<SponsorsCategoryList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="sponsors-category-create" />
                  }
                >
                  <Route
                    path="/create/sponsors-category"
                    element={<CreateSponsorCategory />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="sponsors-category-edit" />
                  }
                >
                  <Route
                    path="/sponsors-category/:id/edit"
                    element={<EditSponsorCategory />}
                  />
                </Route>
                {/* --- Blood Groups --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="blood-groups-list" />
                  }
                >
                  <Route path="/blood-groups" element={<BloodgroupList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="blood-groups-create" />
                  }
                >
                  <Route
                    path="/create/blood-group"
                    element={<CreateBloodgroup />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="blood-groups-edit" />
                  }
                >
                  <Route
                    path="/blood-group/:id/edit"
                    element={<EditBloodgroup />}
                  />
                </Route>
                {/* --- Currency Masters --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="currency-master-list" />
                  }
                >
                  <Route path="/currency" element={<CurrencyList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="currency-master-create" />
                  }
                >
                  <Route
                    path="/create/currency-master"
                    element={<CreateCurrency />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="currency-master-edit" />
                  }
                >
                  <Route
                    path="/currency-master/:id/edit"
                    element={<EditCurrency />}
                  />
                </Route>
                {/* --- Timers --- */}
                <Route
                  element={<PrivatePermissionRoute permission="timers-list" />}
                >
                  <Route path="/timers" element={<TimersList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="timers-create" />
                  }
                >
                  <Route path="/create/timer" element={<CreateTimer />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="timers-edit" />}
                >
                  <Route path="/timer/:id/edit" element={<EditTimer />} />
                </Route>
                {/* --- Timer Access --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="timer-access-list" />
                  }
                >
                  <Route path="/timer-access" element={<EditTimerAccess />} />
                </Route>
                {/* --- Circle Finance Access --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="chapter-finance-access-list" />
                  }
                >
                  <Route path="/chapter-finance-access" element={<EditChapterFinanceAccess />} />
                </Route>
                {/* Client: Crowns paused for now
                --- Crowns ---
                <Route
                  element={
                    <PrivatePermissionRoute permission="crowns-list" />
                  }
                >
                  <Route path="/crowns" element={<CrownsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="crowns-create" />
                  }
                >
                  <Route
                    path="/create/crown"
                    element={<CreateCrown />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="crowns-edit" />
                  }
                >
                  <Route
                    path="/crown/:id/edit"
                    element={<EditCrown />}
                  />
                </Route>
                */}

                <Route element={<PrivateAdminRoute allowedRoles={[1]} />}>
                  {/* --- Countries --- */}
                  <Route
                    element={
                      <PrivatePermissionRoute permission="countries-list" />
                    }
                  >
                    <Route path="/countries" element={<CountrysList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="countries-create" />
                    }
                  >
                    <Route path="/create/country" element={<CreateCountry />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="countries-edit" />
                    }
                  >
                    <Route path="/country/:id/edit" element={<EditCountry />} />
                  </Route>
                </Route>
                <Route element={<PrivateAdminRoute allowedRoles={[1, 6]} />}>
                  {/* --- States --- */}
                  <Route
                    element={<PrivatePermissionRoute permission="states-list" />}
                  >
                    <Route path="/states" element={<StatesList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="states-create" />
                    }
                  >
                    <Route path="/create/state" element={<CreateState />} />
                  </Route>
                  <Route
                    element={<PrivatePermissionRoute permission="states-edit" />}
                  >
                    <Route path="/state/:id/edit" element={<EditState />} />
                  </Route>
                </Route>
                <Route element={<PrivateAdminRoute allowedRoles={[1, 6, 7]} />}>
                  {/* --- Cities --- */}
                  <Route
                    element={<PrivatePermissionRoute permission="citys-list" />}
                  >
                    <Route path="/citys" element={<CitysList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="city-create" />
                    }
                  >
                    <Route path="/create/city" element={<CreateCity />} />
                  </Route>
                  <Route
                    element={<PrivatePermissionRoute permission="city-edit" />}
                  >
                    <Route path="/city/:id/edit" element={<EditCity />} />
                  </Route>
                </Route>
                <Route element={<PrivateAdminRoute allowedRoles={[1, 6, 7, 8]} />}>
                  {/* --- Regions --- */}
                  <Route
                    element={
                      <PrivatePermissionRoute permission="regions-list" />
                    }
                  >
                    <Route path="/regions" element={<RegionsList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="regions-create" />
                    }
                  >
                    <Route path="/create/region" element={<CreateRegion />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="regions-edit" />
                    }
                  >
                    <Route path="/region/:id/edit" element={<EditRegion />} />
                  </Route>
                </Route>
                <Route element={<PrivateAdminRoute allowedRoles={[1, 6, 7, 8, 2]} />}>
                  {/* --- Circles --- */}
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapters-list" />
                    }
                  >
                    <Route path="/chapters" element={<ChaptersList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapters-create" />
                    }
                  >
                    <Route path="/create/chapter" element={<CreateChapter />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapters-edit" />
                    }
                  >
                    <Route path="/chapter/:id/edit" element={<EditChapter />} />
                  </Route>
                </Route>
                {/* --- Points System --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="points-system-list" />
                  }
                >
                  <Route path="/points-system" element={<PointsSystem />} />
                </Route>
                {/* --- Roles & Permissions --- */}
                <Route
                  element={<PrivatePermissionRoute permission="roles-list" />}
                >
                  <Route path="/roles" element={<RolesList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="roles-create" />
                  }
                >
                  <Route path="/create/role" element={<CreateRole />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="roles-edit" />}
                >
                  <Route path="/role/:id/edit" element={<EditRole />} />
                </Route>
                {/* --- Attendance QR Code / Settings --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="settings-list" />
                  }
                >
                  <Route path="/settings" element={<Settings />} />
                </Route>
                {/* --- Forum Settings --- */}
                <Route
                  element={
                    <PrivatePermissionRoute permission="forum-settings-list" />
                  }
                >
                  <Route
                    path="/forum-settings"
                    element={<ForumSettingsEdit />}
                  />
                </Route>
                {/* --- Member Monthly Reports (Super Admin) --- */}
                <Route element={<PrivateAdminRoute allowedRoles={[1]} />}>
                  <Route
                    path="/member_monthly_reports"
                    element={<MemberMonthlyReportsList />}
                  />
                </Route>
                {/* --- Change Password --- */}
                <Route path="/change-password" element={<ChangePassword />} />
                {/* --- Logout --- */}
                <Route path="/logout" element={<Logout />} />

              </Route>
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditionsPage />}
            />
          </Routes>
        </Router>
      </ApplicationProvider>
    </>
  );
}

export default App;
